import _ from 'lodash'
import moment from 'moment'
import * as models from '../models'

const isJson = (str) => {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
}

export const getModel = (modelName) => {
    if (models[modelName]) {
        return models[modelName]
    }

    return null
}

export const getModelName = (relModelName, attribute) => {
    const relModel = getAttributes(relModelName)

    if (relModel && relModel.hasOwnProperty(attribute)) {
        return relModel[attribute].model || relModel[attribute].collection
    }

    return null
}

export const hasModel = (relModelName, attribute) => {
    return !!getModelName(relModelName, attribute)
}

export const getAttributes = (modelName) => {
    const model = getModel(modelName)

    if (model && model.hasOwnProperty('attributes')) {
        return model.attributes
    }

    return null
}

export const getAttribute = (modelName, attribute) => {
    const attributes = getAttributes(modelName)

    if (attributes && attributes.hasOwnProperty(attribute)) {
        return attributes[attribute]
    }

    return null
}

export const getAttributeType = (modelName, attr) => {
    const attribute = getAttribute(modelName, attr)

    if (attribute) {
        switch (true) {
            case attribute.hasOwnProperty('model'):
                return 'model'

            case attribute.hasOwnProperty('collection'):
                return 'collection'

            case attribute.hasOwnProperty('api'):
                return 'api'

            case attribute.hasOwnProperty('columnType'):
                return attribute.columnType

            default:
                return attribute.type
        }
    } else if (attr === 'createdAt' || attr === 'updatedAt') {
        return 'datetime'
    }

    return null
}

export const getValue = (values, prop) => {

    if (values && values.hasOwnProperty(prop)) {
        if (_.isArray(values[prop])) {
            return _.map(values[prop], 'id')
        } else if (typeof values[prop] === 'object'
            && values[prop]
            && values[prop].hasOwnProperty('id')) {
            return values[prop].id
        }

        return values[prop]
    }
    return null
}

export const valueTypeAdapter = (values) => {
    if (values.customer && isJson(values.customer) && typeof values.customer !== 'number') {
        values.customer = (JSON.parse(values.customer)).id;
    }
    return _.mapValues(values, i => {
        const date = moment(i)
        const length = `${i}`.length

        if (date.isValid() && length === 13) {
            return date.format('YYYY-MM-DD HH:mm:ss')
        }

        return i
    })
}

export const getBelongsToValue = (model, belongsTo) => {
    const type = getAttributeType(model, belongsTo.association)

    return type === 'collection' ? [belongsTo.id] : belongsTo.id
}

export const getAttributeAssociation = (model, attribute) => {
    const type = getAttributeType(model, attribute)

    if (type === 'collection') {
        return getAttribute(model, attribute).via
    } else if (type === 'model') {
        const attributeModel = getModelName(model, attribute)
        const attributes = getAttributes(attributeModel)

        return _.findKey(attributes, { collection: model, via: attribute })
    } else {
        return null
    }
}



// WEBPACK FOOTER //
// ./src/utils/models.js